import { Theme } from "@mui/material";

const useStyles = (theme: Theme) => {
  return {
    container: { marginBottom: 2 },
    paper: {
      backgroundColor: theme.palette.background.default,
      display: "flex",
      flexDirection: "column",
      gap: 1.5,
      borderRadius: "1rem",
      padding: 3,
      height: "fit-content",
    },
    accordionDetails: { display: "flex", flexDirection: "column", gap: 1.5 },
    switchFormControl: {
      width: "50%",
      display: "flex",
      alignItems: "start",
      justifyContent: "start",
    },
    stackSwitch: {
      display: "flex",
      flexDirection: "row",
      width: "100%",
      height: "fit-content",
    },
    textField: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      width: "100%",
      marginBottom: 1.5,
    },
    switchLabel: {
      color: theme.palette.text.secondary,
      alignItems: "start",
      marginLeft: 0,
      "& .MuiFormControlLabel-label": {
        fontSize: "14px",
      },
    },
    radialContainer: {
      display: "flex",
      alignItems: "start",
      justifyContent: "space-between",
      width: "100%",
      paddingBottom: 3,
      borderBottom: `1px solid ${theme.palette.background.textField}`,
    },
    typographyOrientation: {
      position: "absolute",
      zIndex: 2,
      color: theme.palette.text.secondary,
      left: 15,
      top: 5,
    },
    dividerContainer: {
      display: "flex",
      gap: 2,
      marginBottom: 2,
      paddingBottom: 2,
      borderBottom: 1,
      borderColor: theme.palette.background.textField,
    },
    selectContainer: {
      backgroundColor: theme.palette.background.paper,
      "& .MuiOutlinedInput-notchedOutline": {
        border: "none",
      },
      paddingTop: 1,
    },
    formControl: {
      width: "100%",
      paddingBottom: 2,
      marginBottom: 2,
      borderBottom: 1,
      borderColor: theme.palette.background.textField,
    },
    datagridTextField: {
      marginBottom: 2,
    },
    alignButton: {
      flex: 1,
      borderRadius: 0,
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      height: "100%",
      border: 2,
      borderColor: "transparent",
    },
  };
};
export default useStyles;
